import { render, staticRenderFns } from "./Parallax-Glider.vue?vue&type=template&id=73604d8e&scoped=true"
import script from "./Parallax-Glider.vue?vue&type=script&lang=js"
export * from "./Parallax-Glider.vue?vue&type=script&lang=js"
import style0 from "./Parallax-Glider.vue?vue&type=style&index=0&id=73604d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73604d8e",
  null
  
)

export default component.exports